import React from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";

import { SALES_PERFORMANCE_COLUMNS } from "./columns";

import { downloadCSV } from "../utils";

const SalesPerformanceItemHeader = ({
  salesperson,
  billableHours,
  children,
  totalBilled
}) => (
  <div className="sales-performance-item-header">
    <h4>{salesperson}</h4>
    <span>{billableHours} Billable Hours</span>
    <span>Total Billed: $ {totalBilled}</span>
    {children}
  </div>
);
SalesPerformanceItemHeader.propTypes = {
  salesperson: PropTypes.string,
  billableHours: PropTypes.number,
  children: PropTypes.node
};
const SalesPerformanceItem = ({
  salesperson,
  billableHours,
  totalBilled,
  projects = []
}) => (
  <div className="content-wrapper sales-performance-item" id={salesperson}>
    <SalesPerformanceItemHeader
      salesperson={salesperson}
      billableHours={billableHours}
      projects={projects}
      totalBilled={totalBilled}
    >
      <button
        className="btn btn-success"
        onClick={() =>
          downloadCSV(salesperson, projects, SALES_PERFORMANCE_COLUMNS)
        }
      >
        Export
      </button>
    </SalesPerformanceItemHeader>
    <ReactTable
      columns={SALES_PERFORMANCE_COLUMNS}
      data={projects}
      showPagination={false}
      pageSize={projects.length}
    />
  </div>
);

SalesPerformanceItem.propTypes = {
  salesperson: PropTypes.string,
  billableHours: PropTypes.number,
  projects: PropTypes.array,
  totalBilled: PropTypes.number
};

SalesPerformanceItemHeader.propTypes = {
  salesperson: PropTypes.string,
  billableHours: PropTypes.number,
  children: PropTypes.node,
  totalBilled: PropTypes.number
};

export default SalesPerformanceItem;
